import NextImage from "@components/NextImage";
import {Btn} from "@components/V5Comp";
import {useTranslation} from "ni18n";
import React from "react";

import {usePartnersConstants} from "../../../constants/Partners";

const Outcomes = (): JSX.Element => {
  const i18n = useTranslation();
  const {ctaProps} = usePartnersConstants();

  return (
    <section className="bg-lightMint pv24 ph4 contrast-tbb" aria-labelledby="outcomes-heading">
      <div className="maxw70 ma df aic jcsb fdc-md">
        <div className="maxw20-md">
          <NextImage
            priority
            src="/partners/nps-score"
            extension="png"
            width={838 / 2}
            height={1342 / 2}
            alt=""
          />
        </div>

        <div className="maxw36 mt8-md">
          <h2 className="fs48 lh12 fs28-md" id="outcomes-heading">
            {i18n.t("Example outcomes from one of our partners")}
          </h2>

          <div className="mt12 lh18 mt2-md ">
            <ul>
              {[
                i18n.t(
                  "50% of Carbon Health primary care patients referred were new to our health system partner",
                ),
                i18n.t("Patient Satisfaction (NPS) of 82"),
                i18n.t("Rapid pace of deployment  (700% clinic growth over 2 years)"),
              ].map(l => (
                <li key={l} className="mt4 df mt6-md">
                  <span className="cIcon-check mt2" aria-hidden />
                  <span className="font-isb ml2">{l}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt2">
            <Btn {...ctaProps} className="mt12" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Outcomes;
